'use client';
import React, { useEffect } from 'react';
import Tooltip from '@ui/Tooltip';
import { isEmpty } from 'lodash-es';
import useStore from '@/stores/store';
import Button from '../next-ui/Button';
import useHasUserSession from '@/hooks/useHasUserSession';
import { authorizedServerFetch } from '@/actions/server.actions';
import useJoinCommunityDialogStore from '../store/joinCommunityDialogSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';
import { getLoginUrlByOrgId } from '@/utils/stringHelpers';

function JoinCommunityButton(props) {
  const {
    community,
    variant = 'outlined',
    color = 'primary',
    pendingApproval = false,
    ...rest
  } = props;

  const communityId = community?.id;
  const primaryCommunityId = community?.primaryCommunityId; // primary Community of group
  const hasSession = useHasUserSession();
  const userCommunities = useStore((state) => state.user?.profile?.communities);

  const [canJoin, setCanJoin] = React.useState(false);

  const setShowJoinCommunityModal = useJoinCommunityDialogStore(
    (state) => state.setOpen,
  );

  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  useEffect(() => {
    if (!hasSession) {
      // setCanJoin(true);
      setCanJoin(!primaryCommunityId); // Allow to join in logged out page if its not a group
    } else if (!isEmpty(userCommunities)) {
      const isUserInCurrentCommunity = userCommunities.some(
        (c) => c.communityId === communityId,
      );

      if (primaryCommunityId) {
        const isUserInPrimary = userCommunities.some(
          (c) => c.communityId === primaryCommunityId,
        );
        setCanJoin(isUserInPrimary && !isUserInCurrentCommunity);
      } else {
        setCanJoin(!isUserInCurrentCommunity);
      }
    }
  }, [userCommunities, communityId, primaryCommunityId, hasSession]);

  const handleJoin = () => {
    if (hasSession) {
      const joinUrlByOrgId = getLoginUrlByOrgId(community?.id);
      if (joinUrlByOrgId) {
        window.location.href = joinUrlByOrgId;
      } else if (community?.visibilityType === 'public') {
        submitPublicCommunityApplication();
      } else {
        setShowJoinCommunityModal(true, community);
      }
    } else {
      // setShowJoinCommunityModal(true, community);
      setShowCompanyConnectPopUp(true, community);
    }
  };

  const submitPublicCommunityApplication = async () => {
    const res = await authorizedServerFetch(
      `users/me/community/${community.id}/apply`,
      {
        method: 'POST',
        body: JSON.stringify({
          message: '',
        }),
      },
    );

    if (res?.ok) {
      setShowJoinCommunityModal(true, community, 'success');
    } else {
      if (res?.status === 409) {
        setShowJoinCommunityModal(true, community, 'error');
      } else {
        setShowJoinCommunityModal(true, community, 'backend-error');
      }
    }
  };

  if (pendingApproval) {
    return (
      <Tooltip content="Pending Approval" className="w-max">
        <Button variant={variant} color={color} {...rest} disabled>
          Join
        </Button>
      </Tooltip>
    );
  }

  if (canJoin) {
    return (
      <Button variant={variant} color={color} {...rest} onClick={handleJoin}>
        Join
      </Button>
    );
  }
  return null;
}

export default JoinCommunityButton;
